// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__20XDV","text":"SelectPayment_text__2OERJ","title":"SelectPayment_title__9wiJO","btn":"SelectPayment_btn__2jEft"};